import { AWS_IMAGE_URL } from '../config';

/** S3 virtual-hosted URL base, e.g. https://bucket.s3.region.amazonaws.com */
export function extractS3PublicBaseFromUrl(fileUrl) {
  if (fileUrl == null || typeof fileUrl !== 'string') return '';
  const trimmed = fileUrl.trim();
  if (!trimmed) return '';

  try {
    const url = new URL(trimmed);
    if (url.hostname.includes('.s3.') && url.hostname.endsWith('.amazonaws.com')) {
      return `${url.protocol}//${url.hostname}`.replace(/\/+$/, '');
    }
  } catch {
    /* ignore invalid URLs */
  }
  return '';
}

const encodeS3ObjectKey = (key) =>
  key
    .split('/')
    .map((segment) => encodeURIComponent(decodeURIComponent(segment)))
    .join('/');

/**
 * Build a browser-ready S3 object URL from a key or an existing absolute URL.
 * @param {string} keyOrUrl - S3 object key or full https URL
 * @param {{ hintObjectUrl?: string }} [options] - Another object URL from the same submission (report PDF, signature) so the correct bucket is used when REACT_APP_AWS_IMAGE_URL points at another environment.
 */
export function buildAwsImageUrl(keyOrUrl, options = {}) {
  if (keyOrUrl == null || keyOrUrl === '') return '';

  const raw = String(keyOrUrl).trim();
  if (!raw) return '';

  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }

  const hintBase = extractS3PublicBaseFromUrl(options.hintObjectUrl);
  const base = (
    hintBase ||
    String(AWS_IMAGE_URL || '')
      .trim()
      .replace(/\/+$/, '')
  );
  const key = raw.replace(/^\/+/, '');

  if (!base) return key;
  if (!key) return base;

  return `${base}/${encodeS3ObjectKey(key)}`;
}
